<template>
  <PageMain
    ref="main"
    :tableData="tableData"
    :loading="loading"
    :tablePage="page"
    @reload="reload"
    @checkbox-change="(d) => $emit('checkbox-change', d)"
  >
    <PageHeader
      ref="header"
      slot="header"
      @query="getData"
      @reset="resetPage"
    />
    <pagination
      slot="pager"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      @change="handlePaginationChange"
    />
  </PageMain>
</template>
<script>
import PageHeader from './header.vue'
import PageMain from './table.vue'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageHeader, PageMain },
  props: { quotationCode: { type: String, default: '' } },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      if (!this.quotationCode) return
      this.loading = true
      this.$api
        .customerQuotationSampleOptionsApi({
          ...form,
          ...this.page,
          quotationCode: this.quotationCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
